import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store'
import zh from './locales/zh'
import en from './locales/en'
import fr from './locales/fr'
import de from './locales/de'
import ja from './locales/ja'
import ko from './locales/ko'

Vue.use(VueI18n)

// 多语言列表
export const languageList = [
  { code: 'zh', name: '中文', flag: 'CN' },
  { code: 'en', name: 'English', flag: 'US' },
  { code: 'fr', name: 'Français', flag: 'FR' },
  { code: 'de', name: 'Deutsch', flag: 'DE' },
  { code: 'ja', name: '日本語', flag: 'JP' },
  { code: 'ko', name: '한국어', flag: 'KR' }
]

const i18n = new VueI18n({
  locale: store.state.locale || 'zh',
  fallbackLocale: 'zh',
  messages: { zh, en, fr, de, ja, ko }
})

export default i18n
